import { React } from "react";
import "../index.css";
import useLanguage from "../../../utils/useLanguage";
import useUpdateDomTitle from "../../../utils/updateDomTitle";
import Email from "../../Views/Common/Email";
import { getTemplateData } from "../../../utils/constants";
import { getDomainCode } from "../../../utils/utils";

let EmailPreview = () => {
  const { t } = useLanguage();
  const domainCode = getDomainCode(process.env.REACT_APP_DOMAIN);
  const templates = getTemplateData(t);
  const emailData = templates[domainCode]?.email ?? templates.q.email;

  useUpdateDomTitle(
    "Online QR Generator - Scanned Page | Email",
    emailData.colors.primary,
  );
  return <Email qrData={emailData} />;
};

export default EmailPreview;
